/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownCommitteeType } from '../models/db_DropdownCommitteeType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class CommitteeTypes {
    /**
     * Get a list of committee types
     * @returns db_DropdownCommitteeType OK
     * @throws ApiError
     */
    public static listCommitteeTypes(): CancelablePromise<Array<db_DropdownCommitteeType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/committee-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
